module.exports = __webpack_public_path__ + "assets/img/1791589512665_.pic_hd.e0900b55.jpg";